import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/tailwindcss.css'
import router from './router' // <-- импортируем наш роутер

createApp(App).use(router).mount('#app') // <-- .use(router) подключает его